import React, { useState, useEffect } from 'react';
import { Box, Grid, MenuItem } from '@mui/material';
import { CustomSelect } from '../../../v2/MUI_custom_component';
import ClubCard from './ClubCard';

const ClubCardsSection = ({ 
  clubCards = [], 
  onActionClick,
  actionButtonLabel = "Create PO",
  showActionButton = true,
  showSelector = true,
  selectorLabel = "Select SAP Code",
  containerSx = {},
  
  onSelectionChange
}) => {
  const [selectedEsiId, setSelectedEsiId] = useState('');
  useEffect(() => {
    if (clubCards && clubCards.length > 0 && !selectedEsiId) {
      setSelectedEsiId(clubCards[0].esi_id);
    }
  }, [clubCards, selectedEsiId]);

  const handleEsiIdChange = (event) => {
    const newSelectedId = event.target.value;
    setSelectedEsiId(newSelectedId);
    
    if (onSelectionChange) {
      onSelectionChange(newSelectedId);
    }
  };

  const filteredClubCards = selectedEsiId 
    ? clubCards.filter(club => club.esi_id === selectedEsiId)
    : clubCards;
  if (!clubCards || clubCards.length === 0) {
    return null;
  }

  return (
    <Box sx={{ 
    display: 'flex', 
    flexDirection: 'column', 
    gap: 2,
    backgroundColor: '#fff',
    p: 2,
    borderRadius: 2,
    ...containerSx
    }}>
    {showSelector  && (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Box sx={{ width: '100%'}}>
            <CustomSelect
            value={selectedEsiId}
            label={selectorLabel}
            onChange={handleEsiIdChange}
            size="small"
            placeholder={selectorLabel}
            fullWidth
            >
            {clubCards.map((club, index) => (
                <MenuItem key={index} value={club.esi_id}>
                {club.sap_code}
                </MenuItem>
            ))}
            </CustomSelect>
        </Box>
        </Box>
    )}
    <Grid container spacing={2}>
        {filteredClubCards.map((club, index) => (
        <ClubCard
            key={index}
            club={club}
            onActionClick={onActionClick}
            actionButtonLabel={actionButtonLabel}
            showActionButton={showActionButton}
        />
        ))}
    </Grid>
    </Box>
  );
};

export default ClubCardsSection;